import { AdvancedFilterDataSchema } from "@redotech/redo-views-common/advanced-filters/advanced-filter-data";
import { SortDirectionSchema } from "@redotech/redo-views-common/table";
import * as z from "zod";

export const exportAdjustmentReport = {
  name: "exportAdjustmentReport" as const,
  input: z.object({
    search: z.string().optional(),
    sortBy: z.string().optional(),
    sortDirection: SortDirectionSchema.optional(),
    advancedFiltersData: z.array(AdvancedFilterDataSchema).optional(),
    visibleColumns: z.array(z.object({ key: z.string(), width: z.number() })),
    sendToEmail: z.string().email().optional(),
  }),
  output: z.object({ exportId: z.string(), fileUrl: z.string().optional() }),
};
